// theme.js
// Central MUI theme. Custom `brand` palette entries expose the gradient and
// surface colors reused across the app so components stop hand-rolling them.

import { createTheme } from "@mui/material/styles";

export const BRAND = {
  bg: "#0f0f13",
  surface: "rgba(25, 25, 30, 0.9)",
  surfaceStrong: "rgba(25, 25, 30, 0.95)",
  cyan: "#39d0ff",
  violet: "#6f5df5",
  textSecondary: "#b0b0b0",
  gradient: "linear-gradient(90deg, #39d0ff, #6f5df5)",
  gradientReverse: "linear-gradient(90deg, #6f5df5, #39d0ff)",
  gradientSoft:
    "linear-gradient(90deg, rgba(111,93,245,0.2), rgba(57,208,255,0.2))",
  divider: "rgba(111,93,245,0.3)",
};

const theme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: BRAND.bg,
      paper: BRAND.surface,
    },
    primary: { main: BRAND.violet },
    secondary: { main: BRAND.cyan },
    text: { primary: "#fff", secondary: BRAND.textSecondary },
  },
  components: {
    // Evaluate media queries on the first render (no desktop-then-mobile
    // flip), so the first client render matches a pre-rendered page.
    MuiUseMediaQuery: { defaultProps: { noSsr: true } },
  },
  typography: {
    fontFamily: '"Poppins","Helvetica","Arial",sans-serif',
    h3: { fontWeight: 700, color: "#fff" },
  },
});

export default theme;
